import { useState, useEffect } from 'react';
import api from '../lib/api';
import { toast } from 'sonner';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';
import { Loader2, ShieldCheck } from 'lucide-react';
import MyConductTab from '../components/conduct/MyConductTab';
import ReportIssueTab from '../components/conduct/ReportIssueTab';
import HRQueueTab from '../components/conduct/HRQueueTab';
import MDApprovalsTab from '../components/conduct/MDApprovalsTab';
import MyReviewsTab from '../components/conduct/MyReviewsTab';
import TeamCardsTab from '../components/conduct/TeamCardsTab';
import SettingsTab from '../components/conduct/SettingsTab';
import DashboardTab from '../components/conduct/DashboardTab';
import EmployeeIdsTab from '../components/conduct/EmployeeIdsTab';

export default function ConductPage() {
  const [capabilities, setCapabilities] = useState(null);
  const [tab, setTab] = useState('mine');

  useEffect(() => {
    api.get('/conduct/me/capabilities')
      .then((res) => {
        setCapabilities(res.data);
        if (res.data.has_team) setTab('report');
        else if (res.data.is_hr) setTab('hr');
        else if (res.data.is_md) setTab('md');
      })
      .catch(() => toast.error('Failed to load Conduct'));
  }, []);

  if (!capabilities) {
    return <div className="flex justify-center py-20" data-testid="conduct-page-loading"><Loader2 className="animate-spin" /></div>;
  }

  return (
    <div className="p-6 space-y-6" data-testid="conduct-page">
      <div className="flex items-center gap-2">
        <ShieldCheck className="h-6 w-6 text-primary" />
        <h1 className="text-2xl font-semibold">Conduct</h1>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <div className="overflow-x-auto -mx-6 px-6 sm:mx-0 sm:px-0" data-testid="conduct-tabs-scroll">
          <TabsList className="w-max">
            <TabsTrigger value="mine" data-testid="conduct-tab-mine">My Conduct</TabsTrigger>
            {capabilities.has_team && <TabsTrigger value="report" data-testid="conduct-tab-report">Report an Issue</TabsTrigger>}
            {capabilities.is_reviewer && <TabsTrigger value="reviews" data-testid="conduct-tab-reviews">My Reviews</TabsTrigger>}
            {capabilities.has_team_cards && <TabsTrigger value="team" data-testid="conduct-tab-team">Team Cards</TabsTrigger>}
            {capabilities.is_hr && <TabsTrigger value="hr" data-testid="conduct-tab-hr">HR Queue</TabsTrigger>}
            {capabilities.is_md && <TabsTrigger value="md" data-testid="conduct-tab-md">MD Approvals</TabsTrigger>}
            {(capabilities.is_hr || capabilities.is_md) && <TabsTrigger value="dashboard" data-testid="conduct-tab-dashboard">Dashboard</TabsTrigger>}
            {(capabilities.is_hr || capabilities.is_md) && <TabsTrigger value="employee-ids" data-testid="conduct-tab-employee-ids">Employee IDs</TabsTrigger>}
            {(capabilities.is_hr || capabilities.is_md) && <TabsTrigger value="settings" data-testid="conduct-tab-settings">Settings</TabsTrigger>}
          </TabsList>
        </div>

        <TabsContent value="mine"><MyConductTab /></TabsContent>
        {capabilities.has_team && <TabsContent value="report"><ReportIssueTab /></TabsContent>}
        {capabilities.is_reviewer && <TabsContent value="reviews"><MyReviewsTab /></TabsContent>}
        {capabilities.has_team_cards && <TabsContent value="team"><TeamCardsTab /></TabsContent>}
        {capabilities.is_hr && <TabsContent value="hr"><HRQueueTab /></TabsContent>}
        {capabilities.is_md && <TabsContent value="md"><MDApprovalsTab /></TabsContent>}
        {(capabilities.is_hr || capabilities.is_md) && <TabsContent value="dashboard"><DashboardTab /></TabsContent>}
        {(capabilities.is_hr || capabilities.is_md) && <TabsContent value="employee-ids"><EmployeeIdsTab isHr={capabilities.is_hr} /></TabsContent>}
        {(capabilities.is_hr || capabilities.is_md) && <TabsContent value="settings"><SettingsTab isMd={capabilities.is_md} /></TabsContent>}
      </Tabs>
    </div>
  );
}
